import styled from '@mui/material/styles/styled';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';

export const StyledListItemButton = styled(ListItemButton)({
  width: '100%',
  gap: '8px',
  overflow: 'hidden',
});
export const ItemTitle = styled((props) => (
  <Typography variant='subtitle1' noWrap {...props} />
))({
  width: '100%',
  fontWeight: 600,
});
export const ItemTimestamp = styled((props) => (
  <Typography color='textSecondary' noWrap  {...props} />
))({
  fontSize: '0.65rem',
  flexShrink: 0,
});